import color from 'color';
import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../v2/style-helper/MediaQueries';

// Sets icon colour based on header background colour
const setIconColor = colorVal => (color(colorVal).isLight() ? '#006800' : '#fff');

export default createUseStyles({
  icon: {
    flexShrink: 0,
    width: 29, // only for IE
    height: 24, // only for IE
    verticalAlign: 'middle',
  },
  
  path: {
    fill: props => setIconColor(props.theme.header.backgroundColour),
  
    [MediaQueries.phone]: {
      fill: props => setIconColor(props.theme.header.mobileBackgroundColour || props.theme.header.backgroundColour),
    },
  },
});
